import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';

import HomeV2 from './pages/Home/HomeV2';
import Settings from './pages/Settings/Settings';
import Campaigns from './pages/Campaigns/Campaigns';
import Messages from './pages/Messages/Messages';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import Leads from './pages/Leads/Leads';
import LeadsWorkspaceShell from './pages/Leads/LeadsWorkspaceShell';
import LeadDetail from './pages/LeadDetail/LeadDetail';
import CampaignDetailOperationsShell from './pages/CampaignDetail/CampaignDetailOperationsShell';
import CampaignAgent from './pages/CampaignAgent/CampaignAgent';
import CampaignAgentApprovals from './pages/CampaignAgent/CampaignAgentApprovals';
import LeadAgentWorkspace from './pages/CampaignAgent/LeadAgentWorkspace';
import HybridFlowConfigurator from './pages/CampaignAgent/HybridFlowConfigurator';
import LinkedInConversationReviews from './pages/CampaignAgent/LinkedInConversationReviews';
import MeetingBookingReviews from './pages/CampaignAgent/MeetingBookingReviews';
import CampaignSourcing from './pages/CampaignSourcing/CampaignSourcing';
import AgentApprovals from './pages/AgentApprovals/AgentApprovals';
import Operations from './pages/Operations/Operations';
import Team from './pages/Team/Team';
import SubscriptionComponent from './pages/Subscription/Subscription';
import ConfirmationPage from './pages/ConfirmationPage/ConfirmationPage';
import Onboarding from './pages/Onboarding/Onboarding';
import SetPassword from './pages/SetPassword/SetPassword';

function RequireAuth({ children }) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AppRouter({ setNotificationStatus }) {
  return (
    <Routes>
      <Route path="/" element={<RequireAuth><HomeV2 /></RequireAuth>} />
      <Route path="/dashboard" element={<RequireAuth><HomeV2 /></RequireAuth>} />
      <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth><Settings setNotificationStatus={setNotificationStatus} /></RequireAuth>} />
      <Route path="/campaigns" element={<RequireAuth><Campaigns /></RequireAuth>} />
      <Route path="/campaigns/:id" element={<RequireAuth><CampaignDetailOperationsShell /></RequireAuth>} />
      <Route path="/campaigns/:id/hybrid-flow" element={<RequireAuth><HybridFlowConfigurator /></RequireAuth>} />
      <Route path="/campaigns/:campaignId/sourcing" element={<RequireAuth><CampaignSourcing /></RequireAuth>} />
      <Route path="/campaigns/:id/agent" element={<RequireAuth><CampaignAgent /></RequireAuth>} />
      <Route path="/campaigns/:id/agent/approvals" element={<RequireAuth><CampaignAgentApprovals /></RequireAuth>} />
      <Route path="/campaigns/:id/agent/linkedin-reviews" element={<RequireAuth><LinkedInConversationReviews /></RequireAuth>} />
      <Route path="/campaigns/:id/agent/meeting-reviews" element={<RequireAuth><MeetingBookingReviews /></RequireAuth>} />
      <Route path="/campaigns/:id/agent/leads/:leadId" element={<RequireAuth><LeadAgentWorkspace /></RequireAuth>} />
      <Route path="/agent/approvals" element={<RequireAuth><AgentApprovals /></RequireAuth>} />
      <Route path="/operations" element={<RequireAuth><Operations /></RequireAuth>} />
      <Route path="/messages" element={<RequireAuth><Messages setNotificationStatus={setNotificationStatus} /></RequireAuth>} />
      <Route path="/leads" element={<RequireAuth><LeadsWorkspaceShell /></RequireAuth>} />
      <Route path="/leads/legacy" element={<RequireAuth><Leads /></RequireAuth>} />
      <Route path="/leads/:id" element={<RequireAuth><LeadDetail /></RequireAuth>} />
      <Route path="/team" element={<RequireAuth><Team /></RequireAuth>} />
      <Route path="/subscription" element={<RequireAuth><SubscriptionComponent /></RequireAuth>} />
      <Route path="/confirmation" element={<ConfirmationPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Signup />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/set-password" element={<RequireAuth><SetPassword /></RequireAuth>} />
    </Routes>
  );
}

export default AppRouter;
